module.exports = __webpack_public_path__ + "img/products.f0629674.svg";